import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EyeNew from './eye-new-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EyeNew {...validProps} />;
}
SvgComponent.iconName = 'eyeNew';

export const EyeNewIcon = svgIconWrapper(SvgComponent);
